"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../../../material/index");

var _thead = _interopRequireDefault(require("./thead/thead"));

var _tbody = _interopRequireDefault(require("./tbody/tbody"));

var _row = _interopRequireDefault(require("./row/row"));

var _head = _interopRequireDefault(require("./head/head"));

var _column = _interopRequireDefault(require("./column/column"));

var _index2 = require("../../../utils/index");

var _listtable_helpers = require("./listtable_helpers");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _listtable_styles = _interopRequireDefault(require("./listtable_styles"));

var _listtable_definition = _interopRequireDefault(require("./listtable_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ========== ~~~~~~~~~~ LIST TABLE ~~~~~~~~~~ ========== */


var ListTable =
/*#__PURE__*/
function (_Component) {
  _inherits(ListTable, _Component);

  function ListTable(props) {
    var _this;

    _classCallCheck(this, ListTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ListTable).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "loadTable", function () {
      return _this.props.loading ? _react.default.createElement("div", {
        className: 'loading'
      }, "loading... ", _react.default.createElement(_index.Loader, {
        name: 'loader'
      })) : _this.displayTable();
    });

    _defineProperty(_assertThisInitialized(_this), "displayTable", function () {
      switch (!!_this.props.data.length) {
        case true:
          return _react.default.createElement("div", {
            className: "tableview"
          }, _react.default.createElement("table", {
            className: "tableelement"
          }, _react.default.createElement(_thead.default, null, _this.props.specialHeads ? _this.createSpecialHeads() : null, _react.default.createElement(_row.default, null, _this.createColumnHeads())), _react.default.createElement(_tbody.default, null, _this.props.specialRow && _this.props.specialRowPosition === 'top' ? _this.createSpecialRow() : null, _this.createRows(_this.getSlicedRowData(_this.state.currentIndex)), _this.props.specialRow && _this.props.specialRowPosition === 'bottom' ? _this.createSpecialRow() : null)));

        case false:
        default:
          return _react.default.createElement(_index.NoDataState, null);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "initialDataSet", function () {
      return _this.hasPagination() ? _this.props.data.slice(0, _this.rowsPerPage) : _this.props.data;
    });

    _defineProperty(_assertThisInitialized(_this), "hasPagination", function () {
      return _this.rowsPerPage < 1 || _this.rowsPerPage === null || _this.rowsPerPage === undefined ? false : true;
    });

    _defineProperty(_assertThisInitialized(_this), "hasHeader", function () {
      return !!_this.props.showTitle || !!_this.props.exportData || !!_this.props.exportAll;
    });

    _defineProperty(_assertThisInitialized(_this), "hasMessage", function () {
      return _this.props.message ? true : false;
    });

    _defineProperty(_assertThisInitialized(_this), "hasFooter", function () {
      return _this.props.moreDetails ? true : false;
    });

    _defineProperty(_assertThisInitialized(_this), "handlePagination", function (e) {
      _this.setState({
        currentIndex: _this.getNewIndex(e)
      }); // reset current row markup based on selected pagination control (show next/prev x number of records)

    });

    _defineProperty(_assertThisInitialized(_this), "getNewIndex", function (e) {
      return e === 'next' ? _this.state.currentIndex + _this.rowsPerPage : _this.state.currentIndex - _this.rowsPerPage;
    });

    _defineProperty(_assertThisInitialized(_this), "getSlicedRowData", function (currentIndex) {
      var newIndex = currentIndex;
      var startIndex = newIndex - _this.rowsPerPage;
      return _this.props.rowsPerPage ? _this.props.data.slice(startIndex, newIndex) : _this.props.data;
    });

    _defineProperty(_assertThisInitialized(_this), "handleAdditionalProps", function (num) {
      var additionalProps = {};

      if (_this.props.type === 'fixed-column' && num <= 1) {
        if (num === 0) {
          additionalProps.isFixedCol = true;
          additionalProps.fixedColWidth = _this.props.fixedColWidth;
        }
      }

      additionalProps.addDataAttribute = _this.props.addDataAttribute;
      return additionalProps;
    });

    _defineProperty(_assertThisInitialized(_this), "createColumnHeads", function () {
      return Object.keys(_this.props.columnHeads).map(function (key, index) {
        var additionalProps = _this.handleAdditionalProps(index);

        var isSortable = !!_this.props.sortableHeads && _this.props.sortableHeads.includes(key);

        return _react.default.createElement(_head.default, _extends({
          key: index,
          isSortable: isSortable,
          onSort: _this.props.onSort,
          headName: key
        }, additionalProps), _this.props.columnHeads[key]);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createRows", function (rowData) {
      return rowData.map(function (row, index) {
        return _react.default.createElement(_row.default, {
          key: index,
          handleClick: row.handleRowClick,
          processing: row.processing,
          disabled: row.disabled
        }, Object.entries(_this.sortColumns(row)).map(function (column, index) {
          var additionalProps = _this.handleAdditionalProps(index);

          return _react.default.createElement(_column.default, _extends({
            key: index
          }, additionalProps), column[1]);
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createSpecialHeads", function () {
      // used for group heads of report preview page (data formatted to deal with colspans)
      return _react.default.createElement(_row.default, {
        klass: "specialhead"
      }, _this.props.specialHeads.map(function (col, index) {
        return _react.default.createElement(_head.default, {
          key: index,
          headName: index,
          colspan: col.colspan
        }, col.colcontent);
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "createSpecialRow", function () {
      // used for totals of report preview page (data formatted to deal with colspans)
      return _react.default.createElement(_row.default, {
        klass: "specialrow"
      }, _this.props.specialRow.map(function (col, index) {
        if (col.colspan > 0) {
          return _react.default.createElement(_column.default, {
            key: index,
            colspan: col.colspan
          }, col.colcontent);
        } else {
          return Object.entries(col.colcontent).map(function (content, nIndex) {
            return _react.default.createElement(_column.default, {
              key: nIndex
            }, content[1]);
          });
        }
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "sortColumns", function (row) {
      // ensure the data we display is in the order of the "columnHeads" prop object we passed through
      // modifying the order of the "columnHeads" prop will affect the display
      if (row !== undefined) {
        var sortedData = [];
        Object.keys(_this.props.columnHeads).forEach(function (head) {
          Object.entries(row).forEach(function (item) {
            if (item[0] === head) {
              sortedData.push(item[1]);
            }
          });
        });
        return sortedData;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "displayPagination", function () {
      return !_this.hasPagination() || _this.rowsPerPage >= _this.props.data.length ? null : _react.default.createElement(_index.StandardPagination, {
        handlePrevious: _this.handlePagination,
        handleNext: _this.handlePagination,
        handlePage: function handlePage(indx) {
          return _this.setState({
            currentIndex: indx * _this.rowsPerPage
          });
        },
        itemsPerPage: _this.rowsPerPage,
        totalPages: _this.props.data.length / _this.rowsPerPage,
        totalItems: _this.props.data.length,
        currentIndex: _this.state.currentIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "displayTableHeader", function () {
      return !_this.hasHeader() ? null : _react.default.createElement(_index.Grid, {
        name: "tableheader"
      }, _react.default.createElement(_index.GridSet, {
        direction: "horizontal"
      }, _react.default.createElement(_index.GridItem, {
        name: "headertitle"
      }, !_this.props.showTitle ? null : _react.default.createElement(_index.Title, {
        size: "small"
      }, _react.default.createElement("h3", null, "Table View"))), _react.default.createElement(_index.GridItem, {
        name: "headerctas"
      }, _this.props.exportData && _react.default.createElement(_index.Link, {
        type: 'action',
        action: function action() {
          return (0, _listtable_helpers.handleExport)(_this.props.exportData.fileName, _this.props.data, _this.props.exportData.excludedColumns);
        },
        text: 'Export Data',
        color: 'supporting',
        icon: "arrow-circle-down",
        iconRight: true
      }), _this.props.exportAll && _react.default.createElement(_index.Link, {
        type: 'action',
        action: function action() {
          return (0, _listtable_helpers.handleExportAll)(_this.props.exportAll.apiCall, _this.props.exportAll.paramString, _this.props.exportAll.fileName, _this.props.exportAll.excludedColumns, _this.props.exportAll.transpiler);
        },
        text: 'Export All',
        color: 'supporting',
        icon: "arrow-circle-down",
        iconRight: true
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "displayTableMessage", function () {
      return !_this.hasMessage() ? null : _react.default.createElement(_index.Group, {
        name: "tablemessage"
      }, _this.props.message);
    });

    _defineProperty(_assertThisInitialized(_this), "displayTableFooter", function () {
      return !_this.hasFooter() ? null : _react.default.createElement(_index.Group, {
        name: "tablefooter"
      }, _react.default.createElement(_index.Link, {
        type: "internal",
        text: "View Full List",
        color: "primary",
        action: "dashboard/analytics/detail/".concat(_this.props.dataType),
        icon: "table",
        iconRight: true
      }));
    });

    _this.rowsPerPage = _this.props.rowsPerPage === 'general' ? 5 : _this.props.rowsPerPage; // set general row amount for tables

    _this.totalRows = _this.props.data.length;
    _this.state = {
      currentIndex: _this.rowsPerPage
    };
    return _this;
  }

  _createClass(ListTable, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.data.length !== this.props.data.length) {
        this.setState({
          currentIndex: this.rowsPerPage
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.rowsPerPage = this.props.rowsPerPage === 'general' ? 5 : this.props.rowsPerPage;
      return _react.default.createElement("div", {
        className: "table listtable tablewrapper ".concat((0, _index2.generateClasses)(this.props), " ").concat(!this.props.variant ? "variant-standard" : null, " ").concat(this.props.paginationLocation ? "paginationLocation-".concat(this.props.paginationLocation) : '', " hasHeader-").concat(this.hasHeader(), " hasMessage-").concat(this.hasMessage(), " hasFooter-").concat(this.hasFooter(), " ").concat(this.props.classes.tablewrapper)
      }, this.displayPagination(), this.displayTableHeader(), this.loadTable(), this.displayTableMessage(), this.displayTableFooter());
    }
  }]);

  return ListTable;
}(_react.Component);

;
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(ListTable, _listtable_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = (0, _reactJss.default)(_listtable_styles.default)(ListTable);

exports.default = _default;